import { ModelFactory } from "../../ModelFactory";

export class AvailablePreviewDomain {
  constructor(
    public readonly id: string,
    public readonly displayName: string,
  ) {
  }
}

class AvailablePreviewDomainsFactory extends ModelFactory<AvailablePreviewDomain> {
  protected fromJson(json: any): AvailablePreviewDomain {
    return new AvailablePreviewDomain(
      json['id'],
      json['display_name'],
    );
  }
}
export const availablePreviewDomainsFactory = new AvailablePreviewDomainsFactory();
